import { render, staticRenderFns } from "./ReferralScore.vue?vue&type=template&id=66f36cfe&"
import script from "./ReferralScore.vue?vue&type=script&lang=ts&"
export * from "./ReferralScore.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralScore.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports